const _ACCEPTABLE_FILE_TYPES = [
  '*',
  '.jpg',
  '.jpeg',
  '.png',
  '.pdf',
  'application/json',
  '.csv',
  '.mp4',
  '.dcm',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.zip',
] as const

const FILE_TYPE_LABELS = {
  '*': 'ALL',
  '.jpg': 'JPG',
  '.jpeg': 'JPEG',
  '.png': 'PNG',
  '.pdf': 'PDF',
  'application/json': 'JSON',
  '.csv': 'CSV',
  '.mp4': 'MP4',
  '.dcm': 'DCM',
  '.doc': 'DOC',
  '.docx': 'DOCX',
  '.xls': 'XLS',
  '.xlsx': 'XLSX',
  '.ppt': 'PPT',
  '.pptx': 'PPTX',
  '.zip': 'ZIP',
} as const

export const ACCEPT_ALL_TYPES = ['*'] as const
const ACCEPT_IMAGE_TYPES = ['.png', '.jpg', '.jpeg'] as const

export const ACCEPT_DOCUMENT_TYPES = [...ACCEPT_IMAGE_TYPES, '.pdf'] as const

const ACCEPT_OFFICE_TYPES = [
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
] as const

export const ACCEPT_WORKSHEET_FILE_TYPES = [
  ...ACCEPT_DOCUMENT_TYPES,
  ...ACCEPT_OFFICE_TYPES,
  '.dcm',
  '.zip',
] as const

export const ACCEPT_REFERRED_PATIENT_FILE_TYPES = [
  ...ACCEPT_DOCUMENT_TYPES,
  ...ACCEPT_OFFICE_TYPES,
  '.dcm',
] as const

export const ACCEPT_TRIAL_SHARED_FILE_TYPES = [
  ...ACCEPT_DOCUMENT_TYPES,
  ...ACCEPT_OFFICE_TYPES,
] as const

export type AcceptableFileType = (typeof _ACCEPTABLE_FILE_TYPES)[number]
type FileTypeLabel = (typeof FILE_TYPE_LABELS)[AcceptableFileType]

type AcceptableOfficeType = (typeof ACCEPT_OFFICE_TYPES)[number]

export const getFileTypeLabel = (
  extension: AcceptableFileType,
): FileTypeLabel => FILE_TYPE_LABELS[extension]

export const isAcceptableOfficeType = (
  fileExtension: string,
): fileExtension is AcceptableOfficeType => {
  return ACCEPT_OFFICE_TYPES.includes(fileExtension as AcceptableOfficeType)
}
